{
  "date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Month",
      "width": 160,
      "isShownByDefault": true
    }
  },
  "oil_equivalent_boe_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d"
    },
    "ui": {
      "label": "Gross Licenced Production",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "oil_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Oil",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "natural_gas_mmcf_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "mmcf/d"
    },
    "ui": {
      "label": "Gross Natural Gas",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "condensate_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d"
    },
    "ui": {
      "label": "Gross Condensate",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "ngl_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross NGL",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "ngl_and_condensate_boe_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d"
    },
    "ui": {
      "label": "NGL & CND"
    }
  },
  "liquid_productions_bbl_d": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d"
    },
    "ui": {
      "label": "Gross Liquid Production",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "provinces_included": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "isNotRenderable": true
    }
  },
  "license_count": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "# total"
    },
    "ui": {
      "label": "Producing Licence Count",
      "width": 120,
      "isShownByDefault": true
    }
  },
  "percent_of_production_as_liquids": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "%"
    },
    "ui": {
      "label": "Percent of Production as Liquids"
    }
  }
}